import WhiteCard from '../Components/WhiteBox'
import Title from './../Components/Title'
import { useSelector } from 'react-redux'
import PublishedWithChangesRoundedIcon from '@mui/icons-material/PublishedWithChangesRounded';
import React from 'react';
import FavuriteCitySelector from '../Components/FavuriteCitySelector';
import { Typography } from '@mui/material';
import DeleteChron from '../Components/DeleteChron';
import Footer from '../Components/Footer';
import DeleteFavurite from '../Components/DeleteFavurite'
import UserKey from '../Components/UserKey';
import SetTheme from '../Components/SetTheme';
import reactDom from 'react-dom';

import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';

export default function Setting() {

  const [openChangeFavuriteCity, setOpenChangeFavuriteCity] = React.useState(false)
  const [openDeleteChron, setOpenDeleteChron] = React.useState(false)
  const [openDeleteFavurite, setOpenDeleteFavurite] = React.useState(false)
  const [openUserKey, setOpenUserKey] = React.useState(false)
  const [openSetTheme, setOpenSetTheme] = React.useState(false)

  const selector = useSelector(state => state.city.city)
  const theme = useSelector(state => state.darkmode.mode)

  const openFavuriteCityModal = () => {
    setOpenChangeFavuriteCity(true)
  }

  const closeFavuriteCityModal = () => {
    setOpenChangeFavuriteCity(false)
  }

  const handleOpenDeleteChron = () => {
    setOpenDeleteChron(true)
  }
  const handleCloseDeleteChron = () => {
    setOpenDeleteChron(false)
  }

  const handleOpenDeleteFavurite = () => {
    setOpenDeleteFavurite(true)
  }

  const handleCloseDeleteFavurite = () => {
    setOpenDeleteFavurite(false)
  }

  const handleOpenUserKey = () => {
    setOpenUserKey(true)
  }

  const handleCloseUserKey = () => {
    setOpenUserKey(false)
  }

  const handleOpenSetTheme = () => {
    setOpenSetTheme(true)
  }

  const handleCloseSetTheme = () => {
    setOpenSetTheme(false)
  }

  return (
    <div style={{height:'100%'}} >
      <div className="container" style={{height:'100%'}}>
        <Title title="Impostazioni" />

        <WhiteCard content={<div><Typography variant="h6" gutterBottom component="div">Modifica città preferita</Typography><p className='text-muted'>{selector ? <>{selector.name}</> : <></>}</p></div>} icon={<PublishedWithChangesRoundedIcon />} selected={openFavuriteCityModal } />
        <FavuriteCitySelector open={openChangeFavuriteCity} handleOpen={openFavuriteCityModal} handleClose={closeFavuriteCityModal} />

        <WhiteCard content={<div><Typography variant="h6" gutterBottom component="div">Tema</Typography><p className='text-muted'>{themeLangMapping[theme]}</p></div>} icon={<DarkModeRoundedIcon />} selected={handleOpenSetTheme} />
        <SetTheme handleOpen={handleOpenSetTheme} handleClose={handleCloseSetTheme} open={openSetTheme}/>

        <WhiteCard content={<Typography variant="h6" gutterBottom component="div">Cancella la cronologia</Typography>} icon={<RestoreRoundedIcon />} selected={handleOpenDeleteChron} />
        <DeleteChron handleOpen={handleOpenDeleteChron} handleClose={handleCloseDeleteChron} open={openDeleteChron} />

        <WhiteCard content={<Typography variant="h6" gutterBottom component="div">Cancella le città preferite</Typography>} icon={<StarRoundedIcon />} selected={handleOpenDeleteFavurite} />
        <DeleteFavurite open={openDeleteFavurite} handleOpen={handleOpenDeleteFavurite} handleClose={handleCloseDeleteFavurite} />

        <WhiteCard content={<div><Typography variant="h6" gutterBottom component="div">Supportaci utilizzando la tua key di Open Weather</Typography><p className='text-muted'>Inserisci la tua key di open weahter per aiutarci a mantenere gratuito e senza pubblicita il servizio</p></div>} icon={<KeyRoundedIcon />} selected={handleOpenUserKey} />
        <UserKey open={openUserKey} handleOpen={handleOpenUserKey} handleClose={handleCloseUserKey} />
      </div>
      <div style={{ display: 'block', height: '70px' }}></div>
      <Footer />
    </div>
  )
}

const themeLangMapping = {
  'light': 'chiaro',
  'dark': 'scuro',
  'system': 'predefinito di sistema'
}